import React from 'react';
import Container from '@material-ui/core/Container';
import T from 'i18n-react';
import Box from '@material-ui/core/Box';
import { ReadMoreButton } from '../Expand/ExpansionText';
import FavoriteIcon from '@material-ui/icons/Favorite';
import Review from './Review';
import InfiniteDialog from '../Scroll/InfiniteDialog';
import Rating from './Rating';
import InfiniteScroller from '../Scroll/InfiniteScroller';
import type { ReviewProps } from './Review';
import type { AtmosphereReviewProps } from '../../front/Plans/AtmosphereReview';
import { ContainerProps as MuiContainerProps } from '@material-ui/core/Container';

type ReviewsProps = Array<ReviewProps>;

type ReviewContainerProps = {
  title?: React.ReactNode,
  apiPath?: string,
  apiResponseConverter?: (reviews: ReviewsProps) => Array<React.Node>,
  next?: boolean,
  reviews?: ReviewsProps,
  atmosphereReviews?: AtmosphereReviewProps,
  ContainerProps?: MuiContainerProps,
  limit?: number,
  reviewsCount?: number,
  totalRating?: number,
  scroller?: boolean,
};

const ReviewContainer = ({
  title,
  reviews = [],
  apiPath,
  next = false,
  apiResponseConverter,
  ContainerProps = {},
  limit,
  atmosphereReviews = [],
  reviewsCount,
  totalRating,
  scroller = false,
}: ReviewContainerProps) => {
  const dialogRef = React.useRef();

  return (
    <Container maxWidth="lg" {...ContainerProps}>
      {title}
      {atmosphereReviews}
      <Rating fontSize="1.05rem" icon={FavoriteIcon} iconSize="1.05em">
        {totalRating}
        {T.translate('totalReviews', { count: reviewsCount })}
      </Rating>
      {reviews.map((reviewProps, index) => (
        <Review key={`review-container${index}`} {...reviewProps} />
      ))}
      {next && scroller ? (
        <>
          <InfiniteScroller
            requestPath={apiPath}
            limit={limit}
            dataRenderer={(reviews) =>
              reviews.map((reviewProps, index) => (
                <Review
                  key={`dialog-review${index}`}
                  {...(!!apiResponseConverter
                    ? apiResponseConverter(reviewProps)
                    : reviewProps)}
                />
              ))
            }
          />
        </>
      ) : (
        next && (
          <>
            <Box textAlign="right" mt={1.5}>
              <ReadMoreButton onClick={() => dialogRef.current?.handleOpen?.()}>
                {T.translate('seeMore')}
              </ReadMoreButton>
            </Box>
            <InfiniteDialog
              DialogContentProps={{ id: 'reviewDialogContentRoot' }}
              requestPath={apiPath}
              ref={dialogRef}
              limit={limit}
              title={T.translate('reviewDialog.title')}
              dataRenderer={(reviews) =>
                reviews.map((reviewProps, index) => (
                  <Review
                    key={`dialog-review${index}`}
                    {...(!!apiResponseConverter
                      ? apiResponseConverter(reviewProps)
                      : reviewProps)}
                  />
                ))
              }
            />
          </>
        )
      )}
    </Container>
  );
};

export default ReviewContainer;
